export default __webpack_public_path__ + "static/media/logo.3d75c2b1.svg";